export default __webpack_public_path__ + "static/media/UraniumOre.256.61bd3949.png";